exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".our-works[data-v-15d92bd4] {\n  padding-top: 20px;\n  padding-bottom: 120px;\n}\n.our-works .content-item[data-v-15d92bd4] {\n  -webkit-transition: 0.3s;\n  transition: 0.3s;\n}\n.our-works .content-item img[data-v-15d92bd4] {\n  height: 265px;\n}\n@media (max-width: 767px) {\n.our-works .content-item img[data-v-15d92bd4] {\n    max-width: 340px;\n    margin-left: auto;\n    margin-right: auto;\n}\n}", ""]);

// exports
